export var createTestStorage = function (map) {
    if (map === void 0) { map = {}; }
    var storage = {
        get: function (key) { return Promise.resolve(map[key]); },
        set: function (key, value) {
            map[key] = value;
            return Promise.resolve(map[key]);
        }
    };
    return storage;
};
//# sourceMappingURL=index.js.map